
(() => {
  const enhance = (root = document) => {
    root.querySelectorAll('.product-grid-container .product-card').forEach((card) => {
      if (card.dataset.tclPriceOverlay === 'true') return;

      const media =
        card.querySelector('.card-gallery') ||
        card.querySelector('.product-card__image') ||
        card.querySelector('[class*="card-gallery"]');

      const priceBlock =
        card.querySelector('product-price[data-block-id]') ||
        card.querySelector('.product-card__content product-price');

      if (!media || !priceBlock) return;

      const priceContainer =
        priceBlock.querySelector('[ref="priceContainer"]') ||
        priceBlock;

      const overlay = document.createElement('div');
      overlay.className = 'tcl-price-overlay';
      overlay.innerHTML = priceContainer.innerHTML;

      media.style.position = 'relative';
      media.appendChild(overlay);

      priceBlock.classList.add('tcl-price-original-hidden');
      priceBlock.setAttribute('aria-hidden', 'true');

      card.dataset.tclPriceOverlay = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', () => enhance());
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) enhance(node);
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('.product-grid-container');
    if (grid) observer.observe(grid, {childList:true, subtree:true});
  });
})();
